<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formattedAverage(value) {
      const resultValue = Number(value);
      if (!isNaN(resultValue)) {
        const roundedValue = resultValue.toFixed(0);
        return new Intl.NumberFormat('id-ID').format(roundedValue);
      }
      return value;
    },
    formattedNumber(value) {
      const resultValue = Number(value);
      if (!isNaN(resultValue)) {
        const roundedValue = resultValue.toFixed(0);
        return new Intl.NumberFormat('id-ID').format(roundedValue);
      }
      return value;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getColorByType(type) {
      switch (type) {
        case 1:
          return "orange";
        case 2:
          return "teal";
        case 3:
          return "red";
        case 4:
          return "blue";
        case 5:
          return "purple";
        default:
          return "grey";
      }
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollLeft -= 200;
        container.behavior = "smooth";
      }
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollLeft += 200;
        container.behavior = "smooth";
      }
    },
  },
};
</script>

<template>
  <div class="py-4 px-10">
    <v-card class="rounded-xl" outlined>
      <v-row no-gutters class="pa-5 text-center">
        <v-col class="text-uppercase my-auto">
          <h3 style="font-size: 14px; font-weight: 600">
            Jumlah LHR Persegmen
          </h3>
          <h1 style="font-size: 42px; font-weight: 500">
            {{ formattedNumber(data.total) }}
          </h1>
          <h3 style="font-size: 16; font-weight: 400; color: #a3a3a3">
            Kendaraan
          </h3>
        </v-col>
        <v-col class="text-uppercase my-auto">
          <h3 style="font-size: 14px; font-weight: 600">
            LHR Persegmen Rerata
          </h3>
          <h1 style="font-size: 42px; font-weight: 500">
            {{ formattedAverage(data.average) }}
          </h1>
          <h3 style="font-size: 16; font-weight: 400; color: #a3a3a3">
            Kendaraan
          </h3>
        </v-col>
      </v-row>

      <v-row no-gutters style="overflow: hidden">
        <v-col
          v-for="(item, index) in data.groups"
          :key="index"
          class="pa-5 custom-border"
          :class="{ 'last-child': index === data.groups.length - 1 }"
        >
          <div class="d-flex align-center">
            <v-avatar
              class="mr-3"
              size="10"
              :color="getColorByType(index)"
            ></v-avatar>
            <div class="text-uppercase">
              <h5 style="font-size: 12px; font-weight: 600">
                Golongan {{ item.group }}
              </h5>
              <h5 class="pr-3" style="font-size: 20px; font-weight: 500">
                {{ formattedNumber(item.total) }}
              </h5>
              <h5 style="font-size: 12px; font-weight: 400; color: #a3a3a3">
                Kendaraan
              </h5>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style scoped>
.custom-border {
  border-top: 1px solid #e8e4e6;
  border-right: 1px solid #e8e4e6;
}

.custom-border.last-child {
  border-right: none;
}
</style>
